import { Reveal, Overline } from "./primitives";

const stages = [
  { n: "01", title: "You", desc: "Meet who you really are. Interrupt self-sabotage. Break old rules. Move through breakdowns without abandoning yourself." },
  { n: "02", title: "Money", desc: "Understand your money story. Redefine what \u201crich\u201d means. Change your relationship with money and recognize your patterns." },
  { n: "03", title: "Possibility", desc: "Find your unfair advantage. See opportunities you literally couldn't see before. Imagine a future that feels bigger and more true." },
  { n: "04", title: "Create", desc: "Generate ideas. Validate them. Make the first imperfect version. Find your first \u201cyes.\u201d Build your version of wealth." },
];

const courses = [
  { n: "01", stage: "You", title: "Meet the Real You" },
  { n: "02", stage: "You", title: "Break Your Own Rules" },
  { n: "03", stage: "You", title: "Interrupt the Pattern" },
  { n: "04", stage: "You", title: "Move Through the Breakdown" },
  { n: "05", stage: "Money", title: "Why Are You Like This With Money?" },
  { n: "06", stage: "Money", title: "Rewrite Your Money Story" },
  { n: "07", stage: "Money", title: "Redefine What Rich Means" },
  { n: "08", stage: "Possibility", title: "Find Your Unfair Advantage" },
  { n: "09", stage: "Possibility", title: "See What You Couldn't See" },
  { n: "10", stage: "Possibility", title: "Imagine a Bigger Future" },
  { n: "11", stage: "Create", title: "Make the First Ugly Version" },
  { n: "12", stage: "Create", title: "Find Your First Yes" },
  { n: "13", stage: "Create", title: "Build Your Version of Wealth" },
];

export const Program = () => (
  <section id="journey" data-testid="program-section" className="bg-ivory py-28 md:py-40">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      {/* Intro */}
      <div className="max-w-3xl">
        <Reveal><Overline>Introducing</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-display text-5xl font-medium leading-[1] tracking-tight text-ink sm:text-6xl lg:text-7xl">
            Creating Wealth Through <span className="italic text-terracotta">Community</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 font-sans text-xl font-light leading-relaxed text-stonegray">
            This isn't "just" an online course. It's a guided journey in four stages — with live coaching and
            community wrapped around you.
          </p>
        </Reveal>
      </div>

      {/* 4 stages */}
      <div className="mt-20 grid gap-px overflow-hidden border border-ink/10 bg-ink/10 md:grid-cols-2 lg:grid-cols-4">
        {stages.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08}>
            <div className="group h-full bg-ivory p-8 transition-colors duration-500 hover:bg-alabaster md:p-10">
              <span className="font-display text-5xl italic text-terracotta/30 transition-colors duration-500 group-hover:text-terracotta">{s.n}</span>
              <h3 className="mt-5 font-display text-3xl text-ink">{s.title}</h3>
              <p className="mt-4 font-sans text-base font-light leading-relaxed text-stonegray">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* The Journey — 13 courses roadmap */}
      <div className="mt-32">
        <Reveal><Overline>The Journey · Thirteen Chapters</Overline></Reveal>
        <Reveal delay={0.05}>
          <h3 className="mt-6 max-w-2xl font-display text-3xl font-medium leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
            A roadmap of transformation.
          </h3>
        </Reveal>

        <div className="mt-14 border-t border-ink/10">
          {courses.map((c, i) => (
            <Reveal key={c.n} delay={Math.min(i, 6) * 0.03}>
              <div className="group grid grid-cols-12 items-center gap-4 border-b border-ink/10 py-6 transition-colors duration-400 hover:bg-alabaster md:py-8">
                <span className="col-span-2 font-sans text-sm tabular-nums text-terracotta md:col-span-1">{c.n}</span>
                <span className="col-span-4 font-sans text-[0.7rem] uppercase tracking-[0.24em] text-stonegray md:col-span-2">{c.stage}</span>
                <span className="col-span-6 font-display text-xl leading-snug text-ink transition-transform duration-400 group-hover:translate-x-2 md:col-span-8 md:text-3xl">
                  {c.title}
                </span>
                <span className="col-span-12 hidden justify-end md:col-span-1 md:flex">
                  <span className="h-2 w-2 rounded-full bg-ink/15 transition-colors duration-400 group-hover:bg-terracotta" />
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
